import TickIcon from 'images/icons/Tick.svg';
import { useCallback } from 'preact/hooks';
import { useUniqueId } from 'utilities/use-unique-id';

import { Icon } from 'components/Icon';
import { Text } from 'components/Text';

import styles from '../../ActionList.module.scss';

interface ItemProps {
  selected?: boolean;
  label: string;
  value: string;
  onChange: (selected: boolean) => void;
}

export function Item({ selected, label, value, onChange }: ItemProps) {
  const id = useUniqueId('ActionListItem');
  const handleChange = useCallback(() => {
    onChange(!selected);
  }, [selected, onChange]);

  return (
    <li className={styles.Item}>
      <label for={id} className={styles.Radio}>
        <span className={styles.RadioControl}>
          <input
            type="radio"
            id={id}
            value={value}
            checked={selected}
            onChange={handleChange}
          />
        </span>
        <span className={styles.RadioLabel}>
          <Text size="small" as="span">
            {label}
          </Text>
        </span>
        {selected && (
          <span className={styles.Icon}>
            <Icon source={TickIcon} />
          </span>
        )}
      </label>
    </li>
  );
}
